import { RouteConfig } from 'vue-router';
const SoftwareFolder = () => import('./views/software/folder.vue');
const ChannelList = () => import('./views/channel/list.vue');
const routers: RouteConfig[] = [
    {
        path: 'software-folder',
        name: 'software-folder',
        component: SoftwareFolder
    },
    {
        path: 'channel-list',
        name: 'channel-list',
        component: ChannelList
    },
    {
        path: '*',
        redirect: 'software-folder'
    },
];
export default routers;

